import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  ensureTrailingSlash,
  errors,
  getBaseUrl,
  Log,
  RidesApi,
} from "@ryde/shared";

import { useRidesNavigation } from "../../navigation/use-rides-navigation";

export const useOpenRideInNewTab = () => {
  const { t } = useTranslation();
  const { getRideEditLinkWithFilters } = useRidesNavigation();

  const openRideInNewTab = useEvent(async (rideId: number) => {
    try {
      const ride = await RidesApi.fetchRide(rideId);

      if (!ride?.id) {
        Log.warnAndToast(t(errors.ride.rideNotFound));
        return;
      }

      const relativePath = getRideEditLinkWithFilters({
        rideId,
        date1: ride.rideStart || new Date().toISOString(),
        date2: ride.rideEnd || new Date().toISOString(),
      });

      const absoluteUrl = `${ensureTrailingSlash(getBaseUrl())}#${relativePath}`;
      window.open(absoluteUrl, "_blank");
    } catch (error) {
      Log.warnAndToast(t(errors.ride.rideNotFound), error);
    }
  });

  return { openRideInNewTab };
};
